import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/auth.store'

export function useAuthRedirect() {
  const navigate = useNavigate()
  const { actions: { clearAll } } = useAuthStore()

  const handleUnauthorized = () => {
    clearAll()
    setTimeout(() => navigate('/login'), 1000)
  }

  return { handleUnauthorized }
}